import React, { useState } from 'react';

// CSS styles for the component
const styles = {
  container: {
    fontFamily: 'monospace',
    fontSize: '14px',
  },
  noData: {
    color: '#6b7280', // gray-500
  },
  null: {
    color: '#6b7280', // gray-500
  },
  boolean: {
    color: '#2563eb', // blue-600
  },
  number: {
    color: '#16a34a', // green-600
  },
  string: {
    color: '#dc2626', // red-600
  },
  key: {
    color: '#9ca3af', // gray-400
  },
  meta: {
    color: '#6b7280', // gray-500
  },
  indent: {
    paddingLeft: '20px',
    borderLeft: '1px solid #d1d5db', // gray-300
    marginLeft: '2px',
  },
  expandable: {
    cursor: 'pointer',
  },
};

const JsonViewer = ({ data }) => {
  if (!data) return <div style={styles.noData}>No data to display</div>;

  return (
    <div style={styles.container}>
      <JsonNode data={data} />
    </div>
  );
};

const JsonNode = ({ data, level = 0 }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpand = () => setIsExpanded(!isExpanded);

  const renderValue = (value) => {
    const type = typeof value;

    if (value === null) return <span style={styles.null}>null</span>;
    if (type === 'undefined') return <span style={styles.null}>undefined</span>;
    if (type === 'boolean') return <span style={styles.boolean}>{value.toString()}</span>;
    if (type === 'number') return <span style={styles.number}>{value}</span>;
    if (type === 'string') return <span style={styles.string}>"{value}"</span>;
    if (Array.isArray(value) || type === 'object') {
      return <JsonNode data={value} level={level + 1} />;
    }

    return String(value);
  };

  const indentStyle = {
    ...styles.indent,
    paddingLeft: level * 20 + 'px',
  };

  if (Array.isArray(data)) {
    const isEmpty = data.length === 0;

    return (
      <div>
        <span style={isEmpty ? styles.meta : styles.expandable} onClick={isEmpty ? undefined : toggleExpand}>
          {isEmpty ? '[ ]' : isExpanded ? '[ ' : '[...] '}
          {!isEmpty && isExpanded && <span style={styles.meta}>{data.length} items</span>}
        </span>

        {!isEmpty && isExpanded && (
          <div>
            {data.map((item, index) => (
              <div key={index} style={indentStyle}>
                <span style={styles.meta}>{index}: </span>
                {renderValue(item)}
                {index < data.length - 1 && <span>,</span>}
              </div>
            ))}
            <div>]</div>
          </div>
        )}
      </div>
    );
  } else if (typeof data === 'object' && data !== null) {
    const keys = Object.keys(data);
    const isEmpty = keys.length === 0;

    return (
      <div>
        <span style={isEmpty ? styles.meta : styles.expandable} onClick={isEmpty ? undefined : toggleExpand}>
          {isEmpty ? '{ }' : isExpanded ? '{ ' : '{...} '}
          {/*{!isEmpty && isExpanded && <span style={styles.meta}>{keys.length} keys</span>}*/}
        </span>

        {!isEmpty && isExpanded && (
          <div>
            {keys.map((key, index) => (
              <div key={key} style={indentStyle}>
                <span style={styles.key}>"{key}"</span>: {renderValue(data[key])}
                {index < keys.length - 1 && <span>,</span>}
              </div>
            ))}
            <div>{'}'}</div>
          </div>
        )}
      </div>
    );
  }

  return renderValue(data);
};

export default JsonViewer;
